{
  "cash": "Cash",
  "noCashAssetClassFound": "No cash asset class found in the configured branches. Please add a cash asset class branch first.",
  "cashFetchError": "Unable to fetch cash financial product. Please try again.",
  "other": "Other",
  "editModel": "Edit Model",
  "details": "Details",
  "disclaimer": "Disclaimer",
  "auditLog": "Audit Log",
  "portfolioAllocation": "Portfolio Allocation",
  "investmentPolicyStatement": "Investment Policy Statement",
  "selectModel": "Select or create a model from the list",
  "primaryAssetClasses": "Primary Asset Classes",
  "secondaryAssetClasses": "Secondary Asset Classes",
  "securities": "Securities",
  "name": "Name",
  "percentage": "Percentage",
  "taxRank": "Tax Rank",
  "secondaryAssetClass": "Asset Class",
  "minimum": "Minimum",
  "maximum": "Maximum",
  "actual": "Actual",
  "unknown": "Unknown",
  "transition": {
    "draft": "Move to Draft",
    "activate": "Move to Active",
    "archive": "Move to Archive"
  },
  "transitionTheme": {
    "successfulTransition": "Theme successfully transitioned",
    "unableToArchiveError": "Unable to archive. This theme is currently assigned to {{numActivePortfolios}} active portfolios.",
    "archiveConfirmationModal": {
      "title": "Are you sure you want to archive?",
      "confirm": "Confirm",
      "cancel": "Cancel"
    }
  },
  "themeModal": {
    "updateTitle": "Update Theme",
    "title": "Create New Theme",
    "key": "Key",
    "name": "Name",
    "description": "Description",
    "shortDescription": "Short Description",
    "organization": "Organization",
    "defaultRecommendation": "Default Recommendation",
    "iconKey": "Icon",
    "successMessages": {
      "create": "Theme has been successfully created.",
      "update": "Theme has been successfully updated."
    },
    "errorMessages": {
      "create": "Unable to create theme try again.",
      "update": "Unable to update theme. Please try again."
    }
  },
  "modelModal": {
    "title": "Create New Model",
    "name": "Name",
    "organization": "Organization"
  },
  "core": "CORE",
  "update": "Update",
  "edit": {
    "name": "Name",
    "porfolioDescription": "Description",
    "investmentObjective": "Investment Objective",
    "theme": "Theme",
    "suggestable": "Suggestible",
    "forecastedRateOfReturn": "Forecasted Rate of Return",
    "forecastedStandardDeviation": "Forecasted Standard Deviation",
    "lowThresholdScore": "Lowest Threshold Score",
    "suggestedMinScore": "Minimum Score",
    "suggestedMaxScore": "Maximum Score",
    "riskReturnLevel": "Risk/Return Level",
    "save": "Save",
    "post": "Post",
    "triggerReSign": {
      "button": "Trigger Re-signing the IPS",
      "triggerButton": "Trigger",
      "confirmationTitle": "Are you sure you want clients to re-sign the agreement?",
      "confirmationMessage": "If you proceed all clients who have this portfolio will need to re-sign their agreement before their accounts will be rebalanced.",
      "updateReason": "Update reason",
      "toastMessage": "Re-signing IPS has been triggered."
    },
    "disclaimerMarkdownLabel": "Portfolio Disclaimer",
    "clear": "Clear",
    "liquidityInfo": "Liquidity",
    "url": "Fund Details Link"
  },
  "editAllocation": {
    "updatedToastMessage": "Model portfolio allocations have been updated."
  },
  "editAccount": {
    "title": "Edit account number",
    "accountNumber": "Account number",
    "update": "Update account number"
  },
  "newNote": {
    "title": "Write a note",
    "characters": "characters",
    "clear": "Yes, clear",
    "cancelClear": "No, don't clear",
    "delete": "Yes, delete",
    "cancelDelete": "No, don't delete",
    "deleteTitle": "Delete Note",
    "deleteSubText": "Are you sure you want to delete this note?",
    "clearTitle": "Clear Note",
    "clearSubText": "Are you sure you want to clear this note?",
    "deleteWarning": "You do not have permission to delete this note.",
    "updateWarning": "You do not have permission to update this note.",
    "noteUserPostFix": "  added:",
    "thereAreNoNotes": "There are no notes to display"
  }
}
